/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { InsertLinkDialog } from '../../../content-edit-controls';
import { urlTemplates, endpoints, linkStyleIframeSrc } from './constants';
import { processInputLinkProp, encodeLinkBeforeSave } from '../../../content-edit-controls/utils/url-utils';

const InsertLinkDialogWindow = ({ onSave, onCancel, params }) =>
{
  const {
    imagesSettings
  } = params;


  const handleSave = (payload) =>
  {
    const data = IRDtoImageSettings(payload);
    onSave(data);
  };

  const IRDtoImageSettings = (settings) => Object.keys(settings).reduce((acc, value) => (
  {
    ...acc,
    [value]: {
      description: settings[value].slideShowImageDescription.trim() || null,
      link: encodeLinkBeforeSave(settings[value].url) || null,
      target: settings[value].openInNewWindow ? '_blank' : '_self',
      title: settings[value].tooltip.trim()  || null
    }
  }), {});

  const imageSettingsToIRD = (settings) => Object.keys(settings).reduce((acc, value) => (
  {
    ...acc,
    [value]: {
      tooltip: settings[value].title || '',
      linkText: '',
      slideShowImageDescription: settings[value].description || '',
      url: processInputLinkProp(settings[value].link || ''),
      openInNewWindow: settings[value].target === null || settings[value].target === '_blank',
      linkStyle: ''
    }
  }), {});


  return (
    <InsertLinkDialog
      isSlideShowInsertLinksMode
      isLinkTextSectionHidden
      isLinkStyleSectionHidden
      imagesSettings={imageSettingsToIRD(imagesSettings)}
      onCancel={onCancel}
      onSave={handleSave}
      baseDetailsUrlTemplate={urlTemplates.baseDetailsUrlTemplate}
      baseRegistrationUrlTemplate={urlTemplates.baseRegistrationUrlTemplate}
      eventsEndpoint={endpoints.eventsEndpoint}
      pagesStructureEndpoint={endpoints.pagesStructureEndpoint}
    />
  );
};

InsertLinkDialogWindow.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired
};


export default InsertLinkDialogWindow;